"use client";

import CustomImage from '@/components/image';
import styles from './_cortisol.module.scss';

export default function HcpCahOverviewCortisol() {

  const chartImage = <CustomImage
    src="/images/page/hcp/cah-overview/CAH-Overview_MOD-Schematic.svg"
    width={628}
    height={444}
    alt="Schematic showing how cortisol deficiency in CAH leads to androgen excess"
  />;

  return (
    <section className={styles.container}>
      <div className={`container ${styles.wrapper}`}>
        <div className={styles.content}>
          <p className={`h1 ${styles.header}`}>Cortisol deficiency in CAH drives dysregulation of HPA axis<sup>3,14</sup></p>
          <h5 className={styles.subheader}>Cortisol deficiency leads to<sup>3,14</sup>:</h5>
          <div className={styles.image_wrapper}>
            <CustomImage
              src="/images/icons/icon-nbr-one.svg"
              width={21}
              height={21}
              alt="Number 1 Icon"
            /><span>Loss of negative feedback in <span className="text-hcp-eggplant">HPA</span> axis</span>
          </div>
          <div className={styles.image_wrapper}>
            <CustomImage
              src="/images/icons/icon-nbr-two.svg"
              width={21}
              height={21}
              alt="Number 2 Icon"
            />Increase in <p className={styles.image_wrapper__highlight}>&nbsp;CRF&nbsp;</p> secretion
          </div>
          <div className={styles.image_wrapper}>
            <CustomImage
              src="/images/icons/icon-nbr-three.svg"
              width={21}
              height={21}
              alt="Number 3 Icon"
            />Increase in <p className={styles.image_wrapper__highlight}>&nbsp;CRF<sub>1</sub></p> &nbsp;receptor activation
          </div>
          <div className={styles.image_wrapper}>
            <CustomImage
              src="/images/icons/icon-nbr-four.svg"
              width={21}
              height={21}
              alt="Number 4 Icon"
            /><span>Systemic surges and constant <span className="text-nowrap">elevation of <span className={`${styles.image_wrapper__highlight} ${styles.black_text}`}>ACTH</span></span></span>
          </div>
          <div className={styles.image_wrapper}>
            <CustomImage
              src="/images/icons/icon-nbr-five.svg"
              width={21}
              height={21}
              alt="Number 5 Icon"
            />Overproduction of <p className={styles.image_wrapper__highlight}>&nbsp;adrenal androgens</p>
          </div>
          <div className={`${styles.content_last} tablet-down:hidden`}>
            {chartImage}
          </div>
          <div className={styles.text_wrapper}>
            <p>95% of CAH cases are caused by 21-hydroxylase deficiency.<sup>12,15</sup></p>
            <p>Because of the 21-hydroxylase deficiency, the adrenal glands cannot make enough cortisol and, in many cases, aldosterone. Instead, they make excess androgens.<sup>3</sup></p>
          </div>
          
        </div>
        <div className={`${styles.content_last} hidden tablet-down:block`}>
          {chartImage}
        </div>
      </div>
    </section>
  );
}